import type { Step } from "react-joyride";

export const checklistDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດ Checklist! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງ Checklist ແລະການຜູກກັບກັບສ່ວນອື່ນໆ ຂອງລະບົບ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການ Checklist ດ້ວຍປຸ່ມ 'ກັບ' ຫຼືແກ້ໄຂ Checklist ນີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ' (ຖ້າທ່ານມີສິດແກ້ໄຂ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານຂອງ Checklist. ທ່ານຈະເຫັນຊື່, ປະເພດ, ສະຖານະ, ຊ່ວງເວລາໃຊ້ງານ, ພະແນກ, ແລະຄຳອະທິບາຍຂອງ Checklist ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-settings"]',
    content:
      "ນີ້ແມ່ນການຕັ້ງຄ່າຂອງ Checklist. ທ່ານຈະເຫັນວ່າ Checklist ນີ້ມີການຕັ້ງຄ່າອັດຕະໂນມັດຫຍັງແດ່ ເຊັ່ນ: ຕ້ອງຕິກຄົບທຸກຂໍ້ກ່ອນຈົບ, ຕ້ອງຖ່າຍຮູບ, ຫຼືຕ້ອງໃສ່ໝາຍເຫດຖ້າບໍ່ຕິກ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-items"]',
    content:
      "ນີ້ແມ່ນລາຍການງານທັງໝົດຂອງ Checklist. ທ່ານຈະເຫັນລາຍການກວດສອບຕ່າງໆ ພ້ອມກັບສະຖານະວ່າລາຍການໃດຈຳເປັນຕ້ອງເຮັດ ແລະລາຍການໃດອະນຸຍາດໃຫ້ເພີ່ມໝາຍເຫດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-mappings"]',
    content:
      "ນີ້ແມ່ນສ່ວນການຜູກກັບ. ທ່ານສາມາດເບິ່ງ, ເພີ່ມ, ແກ້ໄຂ, ຫຼືລຶບການຜູກກັບ Checklist ນີ້ກັບ SOP, Flow, ຕໍາແໜ່ງ, ແລະພະແນກ. ການຜູກກັບຈະຊ່ວຍໃຫ້ Checklist ນີ້ຖືກນຳໃຊ້ອັດຕະໂນມັດໃນສະຖານະການທີ່ກຳນົດໄວ້.",
    placement: "top",
  },
];
